import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const publicTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#7a1238',
      dark: '#4d0a24',
      light: '#a64b6e'
    },
    secondary: {
      main: '#17191b'
    },
    background: {
      default: '#f7f2ea',
      paper: '#fffdf9'
    },
    text: {
      primary: '#171719',
      secondary: '#706966'
    }
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', 'Helvetica', 'Arial', sans-serif",
    button: {
      fontWeight: 700,
      textTransform: 'none'
    }
  },
  shape: {
    borderRadius: 8
  }
});

const PublicThemeProvider = ({ children }) => (
  <ThemeProvider theme={publicTheme}>{children}</ThemeProvider>
);

export default PublicThemeProvider;
